/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetOrgOptions, AdminGetOrgStatus200, AdminGetOrgStatus422 } from '../models/AdminGetOrg'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetOrg } from '../clients/axios/adminGetOrg'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetOrgQueryKey = ({ path }: Omit<AdminGetOrgOptions, 'headers'>) => [{ url: '/admin/org/:org_id', params: path }] as const

type AdminGetOrgQueryKey = ReturnType<typeof adminGetOrgQueryKey>

export function adminGetOrgQueryOptions({ path }: AdminGetOrgOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetOrgQueryKey({ path })
  return queryOptions<AdminGetOrgStatus200, ResponseErrorConfig<AdminGetOrgStatus422>, AdminGetOrgStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetOrg({ ...config, path, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Org
 * {@link /admin/org/:org_id}
 */
export function useAdminGetOrg<TData = AdminGetOrgStatus200, TQueryData = AdminGetOrgStatus200, TQueryKey extends QueryKey = AdminGetOrgQueryKey>({ path }: { path: AdminGetOrgOptions['path'] | (() => AdminGetOrgOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<AdminGetOrgStatus200, ResponseErrorConfig<AdminGetOrgStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? adminGetOrgQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetOrgQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetOrgStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
